import Fuse from 'fuse.js';
import removeAccents from 'remove-accents';

const normalizeText = (value) => removeAccents(String(value).toLowerCase()).trim();
const keepDigits = (value) => String(value).replace(/\D/g, '');

// A search made only of digits, spaces, dots or a leading + is a phone number
// or a BeSTT id: compared on digits alone, whatever the typed formatting.
const isNumericSearch = (search) => /^[\d\s.+-]+$/.test(search);

// A key's own getFn replaces Fuse's global one, so each key normalizes itself.
const FUSE_OPTIONS = {
  keys: [
    // Both orders, so "jean dupont" and "dupont jean" match the same person.
    {
      name: 'fullName',
      getFn: (c) => normalizeText(`${c.firstname || ''} ${c.lastname || ''}`),
    },
    {
      name: 'reversedName',
      getFn: (c) => normalizeText(`${c.lastname || ''} ${c.firstname || ''}`),
    },
    { name: 'email', getFn: (c) => normalizeText(c.email || '') },
    { name: 'phone', getFn: (c) => keepDigits(c.phone || '') },
    { name: 'idBestt', getFn: (c) => (c.id_bestt == null ? '' : String(c.id_bestt)) },
  ],
  threshold: 0.3,
  ignoreLocation: true,
  includeScore: true,
};

/**
 * Filters candidate lists grouped by category ({ complete: [...], ... }) with
 * the same grouping kept. The lists hold the whole mission, so each sub-tab can
 * search its own list without the others changing. Inside a group, matches
 * come by relevance, as the API search used to return them.
 */
const filterCandidatesBySearch = (categorizedLists, search) => {
  if (!categorizedLists || typeof categorizedLists !== 'object') return categorizedLists;

  const trimmedSearch = String(search || '').trim();
  if (trimmedSearch.length < 2) return categorizedLists;

  const query = isNumericSearch(trimmedSearch)
    ? keepDigits(trimmedSearch)
    : normalizeText(trimmedSearch);

  return Object.fromEntries(
    Object.entries(categorizedLists).map(([category, candidates]) => {
      if (!Array.isArray(candidates) || candidates.length === 0) {
        return [category, candidates];
      }
      const matches = new Fuse(candidates, FUSE_OPTIONS)
        .search(query)
        .map(({ item }) => item);
      return [category, matches];
    })
  );
};

export default filterCandidatesBySearch;
